export const mapEdges = (items, callback=false) => {
    return items.edges.map(({ node : item }) => callback === false ? item : callback(item))
}

export const hasNextPage = (items) => {
    return items.pageInfo?.hasNextPage
}
